'use client';

import React from 'react';
import { ChevronDown, Search, Sparkles, Video } from 'lucide-react';

const CTAMockup: React.FC = () => {
  const projects = [
    {
      title: 'How to Remove Watermark from Ima...',
      date: 'Dec 23, 2025, 12:30 PM',
      thumbnail: 'watermark',
      status: 'Rendered'
    },
    {
      title: 'How to create gmail account',
      date: 'Dec 17, 2025, 6:39 PM',
      thumbnail: 'mac',
      status: null
    },
    {
      title: 'How to Remove Watermark from Ima...',
      date: 'Dec 23, 2025, 12:30 PM',
      thumbnail: 'watermark',
      status: 'Rendered'
    },
    {
      title: 'How to create gmail account',
      date: 'Dec 17, 2025, 6:39 PM',
      thumbnail: 'meeting',
      status: 'Rendered'
    }
  ];

  return (
    <div className="bg-[#FFFDF5] rounded-xl shadow-lg overflow-hidden w-full max-w-md mx-auto text-left">
      {/* Header Section */}
      <div className="px-4 py-5 text-center border-b border-gray-100">
        {/* Video Icon */}
        <div className="w-9 h-9 bg-primary rounded-lg flex items-center justify-center mx-auto mb-2">
          <Video className="w-4 h-4 text-white" />
        </div>

        {/* Title */}
        <h3 className="text-base font-bold text-gray-900 mb-1.5">
          New Video Project
        </h3>

        {/* Description */}
        <p className="text-[10px] text-gray-600 mb-3 max-w-xs mx-auto leading-relaxed">
          Upload your screen recording and let our AI generate the perfect
          voiceover.
        </p>

        {/* CTA Button */}
        <button className="bg-primary hover:bg-primary/90 text-white font-medium px-4 py-2 rounded-lg text-xs transition-colors mb-2">
          Create New Project
        </button>

        {/* AI Badge */}
        <div className="flex items-center justify-center gap-1 text-gray-600">
          <Sparkles className="w-3 h-3" />
          <span className="text-[10px]">AI-powered Voice Generation</span>
        </div>
      </div>

      {/* Projects Section */}
      <div className="px-3 py-3 bg-white">
        {/* Projects Header */}
        <h4 className="text-sm font-bold text-gray-900 mb-2">Projects</h4>

        {/* Filters Row */}
        <div className="flex gap-2 mb-2">
          {/* Dropdown */}
          <div className="flex items-center gap-1 bg-white border border-gray-200 rounded-md px-2 py-1 text-[9px] text-gray-700">
            <span>All Stages</span>
            <ChevronDown className="w-3 h-3" />
          </div>

          {/* Search */}
          <div className="flex items-center gap-1 bg-white border border-gray-200 rounded-md px-2 py-1 flex-1">
            <Search className="w-3 h-3 text-gray-400" />
            <span className="text-[9px] text-gray-400">Search...</span>
          </div>

          {/* Status Tabs */}
          <div className="flex items-center gap-0.5 bg-white border border-gray-200 rounded-md p-0.5">
            {['All', 'Completed', 'Processing'].map((tab, idx) => (
              <span
                key={tab}
                className={`px-1.5 py-0.5 text-[8px] rounded ${
                  idx === 0
                    ? 'bg-gray-100 text-gray-900 font-medium'
                    : 'text-gray-600'
                }`}
              >
                {tab}
              </span>
            ))}
          </div>
        </div>

        {/* Project Cards Grid */}
        <div className="grid grid-cols-4 gap-1.5">
          {projects.map((project, idx) => (
            <div
              key={idx}
              className="bg-white rounded-md overflow-hidden border border-gray-100"
            >
              {/* Thumbnail */}
              <div className="relative aspect-video bg-gradient-to-br from-gray-800 to-gray-900 overflow-hidden">
                {project.thumbnail === 'watermark' && (
                  <div className="absolute inset-0 bg-gradient-to-br from-gray-900 to-gray-800 flex items-center justify-center p-1">
                    <div className="text-center">
                      <div className="text-[6px] text-red-500 font-bold">
                        FREE
                      </div>
                      <div className="text-[5px] text-white leading-tight">
                        AI Watermark Remover
                      </div>
                    </div>
                  </div>
                )}
                {project.thumbnail === 'mac' && (
                  <div className="absolute inset-0 bg-gradient-to-br from-orange-200 to-orange-300 flex items-center justify-center">
                    <div className="w-1/2 h-1/2 bg-gray-800 rounded-sm"></div>
                  </div>
                )}
                {project.thumbnail === 'meeting' && (
                  <div className="absolute inset-0 bg-gradient-to-br from-blue-100 to-blue-200 flex items-center justify-center">
                    <div className="grid grid-cols-2 gap-0.5 w-3/4">
                      {[1, 2, 3, 4].map((i) => (
                        <div
                          key={i}
                          className="aspect-video bg-gray-300 rounded-sm"
                        ></div>
                      ))}
                    </div>
                  </div>
                )}
                {project.status && (
                  <span className="absolute top-0.5 left-0.5 bg-primary text-white text-[5px] px-1 py-0.5 rounded font-medium">
                    {project.status}
                  </span>
                )}
              </div>

              {/* Info */}
              <div className="p-1">
                <h5 className="text-[7px] font-medium text-gray-900 truncate">
                  {project.title}
                </h5>
                <p className="text-[6px] text-gray-500">{project.date}</p>

                {/* Tags */}
                <div className="flex items-center gap-0.5 mt-1">
                  {['EN', 'MP4', '4K'].map((tag) => (
                    <span
                      key={tag}
                      className="px-0.5 py-0.5 bg-gray-100 text-gray-600 text-[5px] rounded font-medium"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CTAMockup;
